import { gridPaths } from '@/shared/hooks';
import { createFeatureGridConfig, type GridConfig } from '@/ui/composites/grid/gridConfigFactory';
import { fetchTestsGrid } from './gridQuery';
import type { TestInclude } from '../data/tests';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { GridFilterModel, GridSortModel } from '@/ui/primitives';
import type { TestListItemDto } from '@flowqa/shared';

export const testsGridConfig = ({
  projectId,
  organisationId,
  include,
  fixedFilters,
  initialSortModel,
  initialFilterModel,
  persistKey,
  includeDeltas = true,
  syncStateToUrl = false,
}: {
  projectId?: string | null;
  organisationId?: string | null;
  include?: TestInclude;
  fixedFilters?: GridQueryInput['filters'];
  initialSortModel?: GridSortModel;
  initialFilterModel?: GridFilterModel;
  persistKey?: string | null;
  includeDeltas?: boolean;
  syncStateToUrl?: boolean;
} = {}): GridConfig<TestListItemDto> =>
  createFeatureGridConfig<TestListItemDto>(
    {
      path: gridPaths.tests,
      queryFn: async (input) =>
        await fetchTestsGrid(projectId, organisationId, input, include, includeDeltas),
      noRowsText: 'No tests found',
      defaultPersistKey: 'tests',
      defaultSortModel: [{ field: 'latestExecutionTimestamp', sort: 'desc' }],
    },
    { fixedFilters, initialSortModel, initialFilterModel, persistKey, syncStateToUrl },
  );

export type TestsGridConfig = ReturnType<typeof testsGridConfig>;
